import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-factoring',
    templateUrl: './factoring.component.html',
    styleUrls: ['./factoring.component.scss']
})
export class FactoringComponent implements OnInit {

    constructor() {
    }

    ngOnInit(): void {
    }

}
